import React, { useContext } from 'react';
import { Context } from 'components/Store';
import { FormikInput } from 'components/UiKit/FormikFields';

const PumpLift = () => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);
  return (
    <FormikInput
      id="pumpLift"
      name="pumpLift"
      label="Pump Lift"
      disabled={!isEnableInfoTabEdit}
      placeholder="Enter pump lift"
    />
  );
};

export default PumpLift;
